import { CanvasSurface, Color, Engine, ThreeRenderer } from '@kite/engine';
import './portal.css';
import { mountDevEditor } from './devEditor';
import { PortalShell } from './PortalShell';

const STAGE_ELEMENT_ID = 'tiny-play-stage';
const CHROME_ELEMENT_ID = 'portal-chrome';
const BACKGROUND = Color.fromHex('#1b2333');

function requireElement(id: string): HTMLElement {
  const element = document.getElementById(id);
  if (element === null) {
    throw new Error(`Tiny-Play could not start: no element with id "${id}".`);
  }
  return element;
}

function bootstrap(): void {
  const stage = requireElement(STAGE_ELEMENT_ID);
  const chrome = requireElement(CHROME_ELEMENT_ID);

  const surface = new CanvasSurface({ container: stage });
  const renderer = new ThreeRenderer({ canvas: surface.canvas });
  renderer.setClearColor(BACKGROUND);

  const engine = new Engine({
    renderer,
    surface,
    pointerTarget: surface.canvas,
    keyboardTarget: window,
    /*
     * The whole document, not the stage: the chrome layer is the canvas' sibling rather than its child,
     * so filling the screen with the stage alone would take the picker and the way back with it.
     */
    fullscreenTarget: document.documentElement,
  });

  /*
   * A game is chosen with an HTML tile, so a whole session can start without the canvas ever being
   * touched. Listening on the document as well means the first tap anywhere is the gesture that lets
   * audio start, rather than the first tap that happens to land on the game.
   */
  engine.context.audio.attachUnlockGesture(document.body, window);

  const shell = new PortalShell({ engine, chrome });
  shell.start();

  if (import.meta.env.DEV) {
    void mountDevEditor(stage, engine.context);
  }
}

bootstrap();
